import { createFileRoute } from "@tanstack/react-router";

import RolesAdmin from "@/components/RolesAdmin";

// Generated to match `src/app/admin/roles/page.tsx`. The route is a passthrough: the console
// component owns everything, and `admin/route.tsx` owns the shell and the gate.
export const Route = createFileRoute("/admin/roles")({
  component: RolesAdmin,
});
